export default {
  VIEWS: {},
};
